import { useState, useCallback, useEffect } from 'react';
import { ApiClientError } from '../../models';
import { apiEventBus } from '../../api';

export function useRunReportErrorHandler(onError: () => void): {
  errorMessage: string | undefined;
  resetError: () => void;
} {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const resetError = useCallback((): void => setErrorMessage(undefined), []);

  const handleApiError = useCallback((msg?: string): void => {
    setErrorMessage(msg);
    onError();
  }, [onError]);

  useEffect(() => {
    const onApiError = (evt: Event): void => {
      const error = (evt as CustomEvent<{ error: ApiClientError<{ message?: string }> }>).detail?.error;
      handleApiError(error?.data?.message ?? error?.errMsg);
    };
    apiEventBus.addErrorListener(onApiError);
    return (): void => apiEventBus.removeErrorListener(onApiError);
  }, [handleApiError]);

  return { errorMessage, resetError };
}
